import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody46';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy46 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Business Requirements </h2><h4>Document (BRD) Development</h4>";

  return (
    <>
        <Helmet>
        <title>Business Requirements Document (BRD) Development</title>
        <meta property="og:title" content="Business Requirements Document (BRD) Development" />
        <meta property='og:description' content='Business Requirements Document (BRD) Development'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy46" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy46
